// extracted by mini-css-extract-plugin
export default {"wrapper":"GlobalContainer_wrapper__XGiP9","container":"GlobalContainer_container__mEzCe"};